import 'twin.macro';
import React from 'react';
import subscriptionUrl from 'containers/UserSettings/Souscription/urls';
import H2 from 'components/Typography/Headings/H2';
import { XMarkIcon as X } from '@heroicons/react/24/outline';
import SimpleModal from 'components/SimpleModal';
import { useNavigate } from 'react-router-dom';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';
import { useGetPlan } from 'queries/plan/useGetPlan';
import { useTranslation } from 'react-i18next';

export function Missing() {
  const user = useUser();
  const navigate = useNavigate();
  const { t } = useTranslation(['userSettings']);

  const { data: plan, isInitialLoading } = useGetPlan(
    user.currentPlan,
    user.locale,
  );
  if (isInitialLoading || !plan) {
    return null;
  }
  const onClose = () => navigate('/settings/subscription');
  return (
    <SimpleModal
      isOpen
      closeModalFct={() => onClose()}
      validateTitle={t(
        'userSettings:subscription.cancel.featureWarningModal.continueCancel',
      )}
      validateAction={() => navigate(subscriptionUrl.reason())}
    >
      <div tw="p-8">
        <H2 tw="mb-8">
          {t('userSettings:subscription.cancel.featureWarningModal.title')}
        </H2>
        <div tw="space-y-2">
          {(plan?.exclusiveFeatures || []).map(f => (
            <div key={f} tw="flex items-center gap-x-2">
              <X tw="h-5 w-5 text-neutral-quiet" />
              <div>{f}</div>
            </div>
          ))}
        </div>
      </div>
    </SimpleModal>
  );
}
